import { useState } from "react";

// ── MOCK DATA ─────────────────────────────────────────────────────────────────
const ADMISSION = {
  id: 1, admission_no: "IPD20260001", status: "Admitted",
  admission_type: "Planned", admission_date: "2026-04-01", admission_time: "09:30:00",
  expected_discharge_date: "2026-04-07", actual_discharge_date: null,
  diagnosis: "Fever and dehydration — moderate grade pyrexia with signs of dehydration",
  source: "Admin", notes: "Patient cooperative and responsive",
  patient_name: "Nikhil Gornod", patient_phone: "+91 98765 43210", patient_image: null,
  doctor_name: "Dr. Priya Mehta", doctor_image: null, specialization: "General Physician",
  ward_title: "General Ward", bed_number: "G-102", clinic_title: "City Health Clinic",
};

const DOCTORS = [
  { id: 1, doctor_name: "Dr. Priya Mehta",   role: "Attending",    specialization: "General Physician" },
  { id: 2, doctor_name: "Dr. Ravi Kumar",    role: "Specialist",   specialization: "Cardiologist" },
  { id: 3, doctor_name: "Dr. Anjali Singh",  role: "Consultant",   specialization: "Endocrinologist" },
];

const VITALS = [
  { id: 3, recorded_at: "2026-04-02 09:00", bp_systolic: 116, bp_diastolic: 76, pulse: 70, temperature: 97.8, temperature_unit: "C", spo2: 98.9, respiratory_rate: 17, blood_glucose: 105, blood_glucose_type: "Post Meal", recorded_by_name: "Nurse Priya", notes: "Improving" },
  { id: 2, recorded_at: "2026-04-01 21:00", bp_systolic: 118, bp_diastolic: 78, pulse: 74, temperature: 99.1, temperature_unit: "C", spo2: 97.8, respiratory_rate: 19, blood_glucose: null, blood_glucose_type: null, recorded_by_name: "Nurse Ravi", notes: "Slight fever in evening" },
  { id: 1, recorded_at: "2026-04-01 09:45", bp_systolic: 120, bp_diastolic: 80, pulse: 72, temperature: 98.6, temperature_unit: "C", spo2: 98.5, respiratory_rate: 18, blood_glucose: 110, blood_glucose_type: "Fasting", recorded_by_name: "Nurse Priya", notes: null },
];

const ROUNDS = [
  { id: 3, round_date: "2026-04-03", round_time: "10:15", doctor_name: "Dr. Priya Mehta", patient_condition: "Stable", complaints: "No major complaints", examination: "Temp 36.8°C, BP 114/74, patient alert", instructions: "Discontinue IV, oral medications only, plan discharge", prescription_changed: 1, next_round_date: null, notes: "Plan discharge tomorrow if stable" },
  { id: 2, round_date: "2026-04-02", round_time: "09:30", doctor_name: "Dr. Priya Mehta", patient_condition: "Improving", complaints: "Mild headache, fever reducing", examination: "Temp 37.2°C, BP 116/76, hydration improved", instructions: "Continue fluids, switch to oral paracetamol", prescription_changed: 1, next_round_date: "2026-04-03", notes: null },
  { id: 1, round_date: "2026-04-01", round_time: "10:00", doctor_name: "Dr. Aakash Yadav", patient_condition: "Under Observation", complaints: "High fever and body ache", examination: "Temp 38.5°C, BP 120/80, mild dehydration", instructions: "Start IV fluids, monitor temp every 4 hrs", prescription_changed: 0, next_round_date: "2026-04-02", notes: null },
];

const NOTES = [
  { id: 4, note_date: "2026-04-02", note_time: "08:30", shift: "Morning", patient_condition: "Improving", note: "Patient awake. Fever subsided. Taking oral fluids well. Appetite improving steadily.", recorded_by_name: "Nurse Priya Sharma" },
  { id: 3, note_date: "2026-04-01", note_time: "23:00", shift: "Night",   patient_condition: "Stable",            note: "Patient sleeping. Vitals stable. No complaints. IV drip running at prescribed rate.", recorded_by_name: "Nurse Ravi Kumar" },
  { id: 2, note_date: "2026-04-01", note_time: "20:00", shift: "Evening", patient_condition: "Stable",            note: "Fever slightly reduced. Patient had dinner. Complaining of mild headache. Paracetamol administered.", recorded_by_name: "Nurse Anjali" },
  { id: 1, note_date: "2026-04-01", note_time: "09:00", shift: "Morning", patient_condition: "Under Observation", note: "Patient admitted with fever. IV line set up. Started fluids. Patient cooperative and responsive.", recorded_by_name: "Nurse Priya Sharma" },
];

const DIETS = [
  { id: 3, diet_type_title: "Normal Diet",  diet_category: "Medical", meal_frequency: "3 Meals", calories_target: 1800, allergies: null,  special_instructions: "Back to normal diet on recovery", valid_from: "2026-04-03", valid_to: null,         active: 1, assigned_by_name: "Dr. Priya Mehta" },
  { id: 2, diet_type_title: "Soft Diet",    diet_category: "Medical", meal_frequency: "5 Meals", calories_target: 1500, allergies: null,  special_instructions: "Soft diet from day 2", valid_from: "2026-04-02", valid_to: "2026-04-02",  active: 0, assigned_by_name: "Dr. Priya Mehta" },
  { id: 1, diet_type_title: "Liquid Diet",  diet_category: "Medical", meal_frequency: "3 Meals", calories_target: 1200, allergies: null,  special_instructions: "Clear liquids only on day 1", valid_from: "2026-04-01", valid_to: "2026-04-01", active: 0, assigned_by_name: "Dr. Aakash Yadav" },
];

const DOCTOR_CHANGES = [
  { id: 1, old_doctor_name: "Dr. Aakash Yadav", new_doctor_name: "Dr. Priya Mehta", reason: "Dr. Aakash on annual leave", changed_at: "2026-04-03 14:00:00", changed_by_name: "Admin User", notes: null },
];

// ── TREATMENT MOCK DATA ───────────────────────────────────────────────────────
const PRESCRIPTIONS = [
  {
    id: 2, prescribed_date: "2026-04-02", prescribed_time: "09:45", prescribed_by_name: "Dr. Priya Mehta",
    notes: "Updated — switched to oral",
    medicines: [
      { id: 4, medicine_title: "Paracetamol", medicine_type: "Tablet", medicine_unit: "mg", dosage: "500mg", route: "Oral", frequency: "Thrice Daily", duration_days: 3, start_date: "2026-04-02", end_date: "2026-04-04", instructions: "After meals with water", active: 1, stop_reason: null },
      { id: 5, medicine_title: "Cetirizine",  medicine_type: "Tablet", medicine_unit: "mg", dosage: "10mg",  route: "Oral", frequency: "Once Daily",   duration_days: 5, start_date: "2026-04-02", end_date: "2026-04-06", instructions: "After meals",           active: 1, stop_reason: null },
    ]
  },
  {
    id: 1, prescribed_date: "2026-04-01", prescribed_time: "10:30", prescribed_by_name: "Dr. Aakash Yadav",
    notes: "Initial prescription on admission",
    medicines: [
      { id: 1, medicine_title: "Paracetamol", medicine_type: "Tablet", medicine_unit: "mg", dosage: "1000mg", route: "IV",   frequency: "Every 6 Hours", duration_days: 5, start_date: "2026-04-01", end_date: null,         instructions: "Dilute in 100ml NS", active: 0, stop_reason: "Switched to oral on day 2" },
      { id: 2, medicine_title: "Omeprazole",  medicine_type: "Capsule",medicine_unit: "mg", dosage: "20mg",   route: "Oral", frequency: "Twice Daily",   duration_days: 5, start_date: "2026-04-01", end_date: "2026-04-05", instructions: "Before meals",       active: 1, stop_reason: null },
    ]
  },
];

const LAB_ORDERS = [
  { id: 1, test_name: "Complete Blood Count (CBC)", ordered_by_name: "Dr. Priya Mehta", order_date: "2026-04-01", status: "Completed", result_value: "WBC: 11.2 K/µL, RBC: 4.5 M/µL, Hgb: 13.2 g/dL, Plt: 220 K/µL", result_date: "2026-04-01", notes: "Mild leukocytosis" },
  { id: 2, test_name: "Liver Function Test (LFT)",  ordered_by_name: "Dr. Priya Mehta", order_date: "2026-04-02", status: "Completed", result_value: "ALT: 32 U/L, AST: 28 U/L, ALP: 85 U/L, Bilirubin: 0.8 mg/dL", result_date: "2026-04-02", notes: "Within normal limits" },
  { id: 3, test_name: "Blood Culture",              ordered_by_name: "Dr. Ravi Kumar",   order_date: "2026-04-02", status: "Pending",   result_value: null, result_date: null, notes: "Awaiting 48-hour incubation" },
  { id: 4, test_name: "Urine Routine & Microscopy", ordered_by_name: "Dr. Priya Mehta", order_date: "2026-04-03", status: "Processing",result_value: null, result_date: null, notes: null },
];

const RADIOLOGY_ORDERS = [
  { id: 1, test_name: "Chest X-Ray (PA View)",  ordered_by_name: "Dr. Priya Mehta", order_date: "2026-04-01", modality: "X-Ray",  status: "Completed", result: "No active consolidation. Heart size normal. Lung fields clear.", result_date: "2026-04-01", notes: null },
  { id: 2, test_name: "Abdominal Ultrasound",   ordered_by_name: "Dr. Ravi Kumar",   order_date: "2026-04-02", modality: "USG",    status: "Completed", result: "Liver and spleen normal. No free fluid. Kidneys appear normal.", result_date: "2026-04-02", notes: "Mild hepatomegaly noted" },
  { id: 3, test_name: "CT Scan Abdomen + Pelvis",ordered_by_name: "Dr. Ravi Kumar",  order_date: "2026-04-03", modality: "CT Scan",status: "Scheduled", result: null, result_date: null, notes: "Scheduled for tomorrow morning" },
];

// ── HELPERS ───────────────────────────────────────────────────────────────────
const initials = n => (n||"?").split(" ").map(x=>x[0]).join("").slice(0,2).toUpperCase();
const fmtDate  = d => new Date(d).toLocaleDateString("en-IN",{day:"numeric",month:"short",year:"numeric"});
const COND_COLOR = { "Stable":"#10b981","Improving":"#3b82f6","Under Observation":"#f59e0b","Critical":"#ef4444","Deteriorating":"#dc2626" };
const COND_BG    = { "Stable":"rgba(16,185,129,.12)","Improving":"rgba(59,130,246,.12)","Under Observation":"rgba(245,158,11,.12)","Critical":"rgba(239,68,68,.12)","Deteriorating":"rgba(220,38,38,.12)" };
const SHIFT_COLOR = { Morning:"#f59e0b", Evening:"#6366f1", Night:"#0891b2" };
const SHIFT_ICON  = { Morning:"☀️", Evening:"🌆", Night:"🌙" };

// ── CSS ───────────────────────────────────────────────────────────────────────
const css = `
@import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@600;700&family=IBM+Plex+Sans:wght@300;400;500;600&family=IBM+Plex+Mono:wght@400;500&display=swap');
*{box-sizing:border-box;margin:0;padding:0;}
:root{
  --bg:#0A0C12; --bg2:#111318; --bg3:#181B24; --bg4:#1E2130;
  --border:#252836; --border2:#2E3348;
  --text:#EDF0FF; --muted:#6B7A99; --dim:#3D4563;
  --accent:#5E7BFF; --accent2:#8B9FFF;
  --green:#10B981; --red:#EF4444; --amber:#F59E0B; --blue:#3B82F6;
  --teal:#0891B2; --purple:#7C3AED;
}
body{background:var(--bg);color:var(--text);font-family:'IBM Plex Sans',sans-serif;min-height:100vh;}
.page{max-width:1160px;margin:0 auto;padding:28px 20px;}
.back-btn{display:inline-flex;align-items:center;gap:6px;font-size:12px;color:var(--muted);background:none;border:none;cursor:pointer;padding:6px 0;margin-bottom:20px;font-family:'IBM Plex Sans',sans-serif;transition:color .15s;}
.back-btn:hover{color:var(--text);}

/* Header card */
.header-card{background:var(--bg2);border:1px solid var(--border);border-radius:16px;padding:24px 28px;margin-bottom:20px;display:grid;grid-template-columns:1fr auto;gap:24px;}
.patient-row{display:flex;align-items:center;gap:16px;margin-bottom:16px;}
.avatar{width:52px;height:52px;border-radius:50%;display:flex;align-items:center;justify-content:center;font-family:'Playfair Display',serif;font-size:18px;font-weight:600;color:#fff;flex-shrink:0;}
.patient-name{font-family:'Playfair Display',serif;font-size:22px;font-weight:700;color:var(--text);}
.patient-phone{font-size:12px;color:var(--muted);margin-top:2px;}
.admission-no{font-family:'IBM Plex Mono',monospace;font-size:11px;color:var(--accent2);background:rgba(94,123,255,.1);padding:3px 10px;border-radius:6px;display:inline-block;margin-bottom:12px;}
.meta-grid{display:grid;grid-template-columns:repeat(4,1fr);gap:10px;}
.meta-item{background:var(--bg3);border-radius:10px;padding:10px 14px;}
.meta-label{font-size:10px;color:var(--muted);text-transform:uppercase;letter-spacing:.07em;margin-bottom:3px;}
.meta-value{font-size:13px;font-weight:500;color:var(--text);}
.status-badge{display:inline-flex;align-items:center;gap:6px;padding:4px 12px;border-radius:20px;font-size:11px;font-weight:600;}
.status-admitted{background:rgba(16,185,129,.12);color:#10b981;}
.status-discharged{background:rgba(239,68,68,.12);color:#ef4444;}
.days-box{background:rgba(16,185,129,.08);border:1px solid rgba(16,185,129,.2);border-radius:12px;padding:16px 24px;text-align:center;min-width:100px;}
.days-num{font-family:'Playfair Display',serif;font-size:42px;font-weight:700;color:#10b981;line-height:1;}
.days-label{font-size:11px;color:var(--muted);margin-top:4px;}

/* Doctors row */
.doctors-row{display:flex;gap:8px;flex-wrap:wrap;margin-bottom:16px;}
.doctor-chip{display:flex;align-items:center;gap:8px;background:var(--bg3);border:1px solid var(--border);border-radius:20px;padding:5px 12px 5px 5px;}
.doc-av{width:26px;height:26px;border-radius:50%;display:flex;align-items:center;justify-content:center;font-size:9px;font-weight:700;color:#fff;}
.doc-name{font-size:12px;font-weight:500;color:var(--text);}
.doc-role{font-size:10px;color:var(--muted);}

/* Tabs */
.tabs{display:flex;gap:2px;background:var(--bg2);border:1px solid var(--border);border-radius:12px;padding:4px;margin-bottom:20px;overflow-x:auto;}
.tab{flex:1;min-width:max-content;padding:8px 14px;border-radius:8px;font-size:12px;font-weight:500;color:var(--muted);cursor:pointer;border:none;background:none;display:flex;align-items:center;gap:6px;justify-content:center;transition:all .15s;font-family:'IBM Plex Sans',sans-serif;white-space:nowrap;}
.tab.active{background:var(--accent);color:#fff;}
.tab:hover:not(.active){background:var(--bg3);color:var(--text);}

/* Cards */
.card{background:var(--bg2);border:1px solid var(--border);border-radius:14px;overflow:hidden;margin-bottom:16px;}
.card-header{padding:14px 20px;border-bottom:1px solid var(--border);display:flex;align-items:center;justify-content:space-between;}
.card-title{font-family:'Playfair Display',serif;font-size:15px;font-weight:600;display:flex;align-items:center;gap:8px;}
.card-accent{width:3px;height:18px;border-radius:2px;display:inline-block;}
.empty-state{padding:40px 20px;text-align:center;color:var(--muted);font-size:13px;}

/* Vitals */
.vitals-row{display:grid;grid-template-columns:repeat(4,1fr);gap:10px;padding:16px 20px;border-bottom:1px solid var(--border);}
.vitals-row:last-child{border-bottom:none;}
.vital-item{background:var(--bg3);border-radius:10px;padding:10px 12px;}
.vital-label{font-size:10px;color:var(--muted);text-transform:uppercase;letter-spacing:.06em;margin-bottom:4px;}
.vital-value{font-family:'IBM Plex Mono',monospace;font-size:16px;font-weight:500;}
.vital-meta{display:flex;align-items:center;justify-content:space-between;padding:10px 20px 4px;border-bottom:1px solid var(--border);}
.vital-meta:last-child{border-bottom:none;}

/* Rounds */
.round-item{padding:16px 20px;border-bottom:1px solid var(--border);}
.round-item:last-child{border-bottom:none;}
.round-header{display:flex;align-items:center;gap:10px;margin-bottom:10px;}
.round-date{font-family:'IBM Plex Mono',monospace;font-size:11px;color:var(--muted);}
.round-grid{display:grid;grid-template-columns:1fr 1fr 1fr;gap:8px;}
.round-field{background:var(--bg3);border-radius:8px;padding:10px 12px;}
.round-field-label{font-size:10px;color:var(--muted);text-transform:uppercase;letter-spacing:.06em;margin-bottom:3px;}
.round-field-value{font-size:12px;color:var(--text);line-height:1.5;}

/* Nursing notes */
.note-item{padding:16px 20px;border-bottom:1px solid var(--border);display:grid;grid-template-columns:auto 1fr;gap:14px;}
.note-item:last-child{border-bottom:none;}
.shift-badge{padding:4px 10px;border-radius:6px;font-size:10px;font-weight:600;text-align:center;min-width:60px;}
.note-text{font-size:13px;color:var(--muted);line-height:1.6;margin-top:4px;}

/* Diet */
.diet-item{padding:14px 20px;border-bottom:1px solid var(--border);display:flex;align-items:center;gap:14px;}
.diet-item:last-child{border-bottom:none;}
.diet-badge{padding:4px 12px;border-radius:20px;font-size:11px;font-weight:600;}
.diet-info{flex:1;}
.diet-name{font-size:14px;font-weight:500;color:var(--text);}
.diet-sub{font-size:12px;color:var(--muted);margin-top:2px;}
.current-tag{font-size:10px;padding:2px 8px;border-radius:10px;background:rgba(16,185,129,.12);color:#10b981;font-weight:600;}
.past-tag{font-size:10px;padding:2px 8px;border-radius:10px;background:var(--bg3);color:var(--muted);font-weight:600;}

/* Doctor changes */
.change-item{padding:16px 20px;border-bottom:1px solid var(--border);display:flex;gap:14px;align-items:flex-start;}
.change-item:last-child{border-bottom:none;}
.change-arrow{display:flex;flex-direction:column;align-items:center;gap:4px;flex-shrink:0;}
.change-from{font-size:12px;color:var(--text);font-weight:500;text-align:center;}
.change-to{font-size:12px;color:var(--green);font-weight:500;text-align:center;}
.arrow-icon{color:var(--accent);font-size:16px;}
.cond-badge{display:inline-flex;align-items:center;gap:4px;padding:3px 10px;border-radius:12px;font-size:11px;font-weight:600;}
.rx-chip{font-size:10px;padding:2px 7px;border-radius:8px;font-weight:600;}
.btn{display:inline-flex;align-items:center;gap:6px;padding:7px 14px;border-radius:8px;font-size:12px;font-weight:500;cursor:pointer;border:none;transition:all .15s;font-family:'IBM Plex Sans',sans-serif;}
.btn-primary{background:var(--accent);color:#fff;}
.btn-primary:hover{background:#4A67E8;}
.btn-ghost{background:var(--bg3);color:var(--text);border:1px solid var(--border2);}
.btn-ghost:hover{border-color:var(--accent);color:var(--accent2);}
.divider{height:1px;background:var(--border);margin:4px 0;}
.tag{font-size:10px;padding:2px 7px;border-radius:6px;font-weight:600;}
.modal-bg{position:fixed;inset:0;background:rgba(0,0,0,.75);z-index:50;display:flex;align-items:center;justify-content:center;padding:20px;}
.modal-box{background:var(--bg2);border:1px solid var(--border2);border-radius:16px;padding:28px;width:100%;max-width:580px;max-height:90vh;overflow-y:auto;}
.modal-title{font-family:'Playfair Display',serif;font-size:17px;font-weight:700;margin-bottom:18px;display:flex;align-items:center;justify-content:space-between;}
.modal-grid{display:grid;grid-template-columns:1fr 1fr;gap:12px;margin-bottom:14px;}
.modal-full{grid-column:1/-1;}
.field{display:flex;flex-direction:column;gap:6px;}
.field label{font-size:11px;font-weight:600;color:var(--muted);text-transform:uppercase;letter-spacing:.07em;}
.input{width:100%;padding:9px 12px;border-radius:8px;border:1px solid var(--border2);background:var(--bg3);color:var(--text);font-size:13px;font-family:'IBM Plex Sans',sans-serif;outline:none;transition:border-color .15s;}
.input:focus{border-color:var(--accent);}
.select-i{appearance:none;cursor:pointer;}
.textarea{resize:vertical;min-height:70px;}
.modal-actions{display:flex;gap:8px;justify-content:flex-end;margin-top:18px;padding-top:14px;border-top:1px solid var(--border);}
.stab{padding:7px 14px;border-radius:0;font-size:12px;font-weight:500;color:var(--muted);cursor:pointer;border:none;background:none;font-family:'IBM Plex Sans',sans-serif;border-bottom:2px solid transparent;transition:all .15s;}
.stab.active{color:var(--accent2);border-bottom-color:var(--accent);}
.stab:hover:not(.active){color:var(--text);}
.treat-sub-tabs{display:flex;gap:0;padding:0 20px;border-bottom:1px solid var(--border);background:var(--bg3);}
.rx-item{padding:14px 20px;border-bottom:1px solid var(--border);}
.rx-item:last-child{border-bottom:none;}
.medicine-row{display:flex;align-items:center;gap:10px;padding:8px 12px;background:var(--bg3);border-radius:8px;margin-bottom:5px;}
.medicine-row:last-child{margin-bottom:0;}
.med-name{font-size:13px;font-weight:500;min-width:110px;}
.med-chip{padding:2px 7px;border-radius:5px;background:var(--bg4);color:var(--muted);font-size:10px;font-weight:500;}
.stopped{background:rgba(239,68,68,.1);color:#ef4444;}
.active-m{background:rgba(16,185,129,.1);color:#10b981;}
.lab-row{padding:14px 20px;border-bottom:1px solid var(--border);}
.lab-row:last-child{border-bottom:none;}
.stat-pill{display:inline-flex;align-items:center;gap:4px;padding:3px 10px;border-radius:12px;font-size:11px;font-weight:600;}
.result-box{background:var(--bg3);border-radius:8px;padding:10px 12px;font-size:12px;color:var(--muted);line-height:1.5;margin-top:8px;}
.icon-btn{width:26px;height:26px;border-radius:6px;border:1px solid var(--border2);background:transparent;color:var(--muted);cursor:pointer;display:inline-flex;align-items:center;justify-content:center;font-size:11px;transition:all .15s;font-family:'IBM Plex Sans',sans-serif;}
.icon-btn:hover{border-color:var(--accent2);color:var(--accent2);}
.icon-btn.del:hover{border-color:#ef4444;color:#ef4444;}
.mod-chip{font-size:10px;padding:2px 8px;border-radius:6px;font-weight:600;}
`;

// ── COMPONENTS ────────────────────────────────────────────────────────────────
const Av = ({ name, size=36, color="#5E7BFF" }) => (
  <div className="avatar" style={{ width:size, height:size, fontSize:size*.33, background:color }}>
    {initials(name)}
  </div>
);

const CondBadge = ({ c }) => (
  <span className="cond-badge" style={{ background:COND_BG[c]||"var(--bg3)", color:COND_COLOR[c]||"var(--muted)" }}>
    <span style={{ width:5,height:5,borderRadius:"50%",background:COND_COLOR[c]||"var(--muted)",display:"inline-block" }}/>
    {c}
  </span>
);

const COLORS = ["#5E7BFF","#10B981","#F59E0B","#0891B2","#7C3AED","#EF4444"];
const doctorColor = (name) => COLORS[(name||"").charCodeAt(0)%COLORS.length];

// ── TAB PANELS ────────────────────────────────────────────────────────────────
function VitalsPanel() {
  return (
    <div className="card">
      <div className="card-header">
        <div className="card-title">
          <span className="card-accent" style={{ background:"#10B981" }}/>
          Vitals Tracking
        </div>
        <button className="btn btn-primary">+ Record Vitals</button>
      </div>
      {VITALS.length === 0 ? <div className="empty-state">No vitals recorded yet</div> : VITALS.map((v, i) => (
        <div key={v.id}>
          <div className="vital-meta">
            <span style={{ fontFamily:"'IBM Plex Mono',monospace", fontSize:11, color:"var(--muted)" }}>{v.recorded_at}</span>
            <span style={{ fontSize:11, color:"var(--muted)" }}>by {v.recorded_by_name}</span>
            {v.notes && <span style={{ fontSize:11, color:"var(--accent2)", fontStyle:"italic" }}>{v.notes}</span>}
          </div>
          <div className="vitals-row">
            {[
              { label:"Blood Pressure", value:`${v.bp_systolic}/${v.bp_diastolic}`, unit:"mmHg", color: v.bp_systolic > 130 ? "#EF4444" : "#10B981" },
              { label:"Pulse",          value:v.pulse,    unit:"bpm",    color:"#F59E0B" },
              { label:"Temperature",    value:`${v.temperature}°${v.temperature_unit}`, unit:"", color: v.temperature > 37.5 ? "#EF4444" : "#10B981" },
              { label:"SpO₂",           value:`${v.spo2}%`, unit:"",   color: v.spo2 < 95 ? "#EF4444" : "#10B981" },
              { label:"Resp. Rate",     value:v.respiratory_rate, unit:"/min", color:"#3B82F6" },
              ...(v.blood_glucose ? [{ label:"Blood Glucose", value:`${v.blood_glucose}`, unit:`mg/dL · ${v.blood_glucose_type}`, color:"#7C3AED" }] : []),
            ].map(item => (
              <div className="vital-item" key={item.label}>
                <div className="vital-label">{item.label}</div>
                <div className="vital-value" style={{ color:item.color }}>{item.value}</div>
                {item.unit && <div style={{ fontSize:10, color:"var(--muted)", marginTop:2 }}>{item.unit}</div>}
              </div>
            ))}
          </div>
          {i < VITALS.length-1 && <div className="divider"/>}
        </div>
      ))}
    </div>
  );
}

function RoundsPanel() {
  return (
    <div className="card">
      <div className="card-header">
        <div className="card-title">
          <span className="card-accent" style={{ background:"#5E7BFF" }}/>
          Doctor Rounds
        </div>
        <button className="btn btn-primary">+ Add Round</button>
      </div>
      {ROUNDS.map(r => (
        <div className="round-item" key={r.id}>
          <div className="round-header">
            <Av name={r.doctor_name} size={30} color={doctorColor(r.doctor_name)}/>
            <div>
              <div style={{ fontSize:13, fontWeight:500 }}>{r.doctor_name}</div>
              <div className="round-date">{r.round_date} · {r.round_time}</div>
            </div>
            <CondBadge c={r.patient_condition}/>
            {r.prescription_changed === 1 && (
              <span className="rx-chip" style={{ background:"rgba(124,58,237,.15)", color:"#7C3AED" }}>Rx Changed</span>
            )}
            {r.next_round_date && (
              <span className="rx-chip" style={{ background:"rgba(59,130,246,.12)", color:"#3B82F6" }}>Next: {r.next_round_date}</span>
            )}
          </div>
          <div className="round-grid">
            {r.complaints && (
              <div className="round-field">
                <div className="round-field-label">Complaints</div>
                <div className="round-field-value">{r.complaints}</div>
              </div>
            )}
            {r.examination && (
              <div className="round-field">
                <div className="round-field-label">Examination</div>
                <div className="round-field-value">{r.examination}</div>
              </div>
            )}
            {r.instructions && (
              <div className="round-field">
                <div className="round-field-label">Instructions</div>
                <div className="round-field-value">{r.instructions}</div>
              </div>
            )}
          </div>
        </div>
      ))}
    </div>
  );
}

function NursingPanel() {
  return (
    <div className="card">
      <div className="card-header">
        <div className="card-title">
          <span className="card-accent" style={{ background:"#0891B2" }}/>
          Nursing Notes
        </div>
        <button className="btn btn-primary">+ Add Note</button>
      </div>
      {NOTES.map(n => (
        <div className="note-item" key={n.id}>
          <div style={{ display:"flex", flexDirection:"column", alignItems:"center", gap:4, minWidth:64 }}>
            <div className="shift-badge" style={{ background:`${SHIFT_COLOR[n.shift]}22`, color:SHIFT_COLOR[n.shift] }}>
              {SHIFT_ICON[n.shift]} {n.shift}
            </div>
            <div style={{ fontFamily:"'IBM Plex Mono',monospace", fontSize:10, color:"var(--muted)" }}>{n.note_time}</div>
            <div style={{ fontFamily:"'IBM Plex Mono',monospace", fontSize:10, color:"var(--dim)" }}>{n.note_date}</div>
          </div>
          <div>
            <div style={{ display:"flex", alignItems:"center", gap:8, marginBottom:6 }}>
              <span style={{ fontSize:12, fontWeight:500, color:"var(--text)" }}>{n.recorded_by_name}</span>
              <CondBadge c={n.patient_condition}/>
            </div>
            <div className="note-text">{n.note}</div>
          </div>
        </div>
      ))}
    </div>
  );
}

function DietPanel() {
  return (
    <div className="card">
      <div className="card-header">
        <div className="card-title">
          <span className="card-accent" style={{ background:"#F59E0B" }}/>
          Diet Plan
        </div>
        <button className="btn btn-primary">+ Assign Diet</button>
      </div>
      {DIETS.map(d => (
        <div className="diet-item" key={d.id}>
          <div>
            <div className="diet-badge" style={{ background:`${d.active ? "#10B981" : "#6B7A99"}22`, color: d.active ? "#10B981" : "#6B7A99" }}>
              {d.active ? "Current" : "Past"}
            </div>
          </div>
          <div className="diet-info">
            <div style={{ display:"flex", alignItems:"center", gap:8 }}>
              <div className="diet-name">{d.diet_type_title}</div>
              <span className="tag" style={{ background:"rgba(94,123,255,.12)", color:"var(--accent2)" }}>{d.diet_category}</span>
              <span className="tag" style={{ background:"var(--bg3)", color:"var(--muted)" }}>{d.meal_frequency}</span>
              {d.calories_target && <span className="tag" style={{ background:"rgba(245,158,11,.12)", color:"#F59E0B" }}>{d.calories_target} kcal</span>}
            </div>
            <div className="diet-sub">
              {d.special_instructions && <span>{d.special_instructions}</span>}
              {d.allergies && <span style={{ color:"#EF4444", marginLeft:8 }}>⚠ Allergies: {d.allergies}</span>}
            </div>
            <div style={{ fontSize:11, color:"var(--muted)", marginTop:4 }}>
              {d.valid_from} → {d.valid_to || "Until discharge"} · Assigned by {d.assigned_by_name}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}

function DoctorChangePanel() {
  return (
    <div className="card">
      <div className="card-header">
        <div className="card-title">
          <span className="card-accent" style={{ background:"#7C3AED" }}/>
          Doctor Changes
        </div>
        <button className="btn btn-primary">+ Change Doctor</button>
      </div>
      {DOCTOR_CHANGES.length === 0 ? (
        <div className="empty-state">No doctor changes during this stay</div>
      ) : DOCTOR_CHANGES.map(c => (
        <div className="change-item" key={c.id}>
          <div className="change-arrow">
            <div className="change-from">{c.old_doctor_name.split(" ").slice(-1)[0]}</div>
            <div className="arrow-icon">↓</div>
            <div className="change-to">{c.new_doctor_name.split(" ").slice(-1)[0]}</div>
          </div>
          <div style={{ flex:1 }}>
            <div style={{ display:"flex", gap:8, alignItems:"center", marginBottom:6 }}>
              <span style={{ fontSize:13, fontWeight:500 }}>{c.old_doctor_name}</span>
              <span style={{ color:"var(--muted)", fontSize:12 }}>→</span>
              <span style={{ fontSize:13, fontWeight:500, color:"#10B981" }}>{c.new_doctor_name}</span>
            </div>
            <div style={{ fontSize:12, color:"var(--muted)", marginBottom:4 }}>
              <span style={{ color:"var(--text)" }}>Reason:</span> {c.reason}
            </div>
            <div style={{ fontSize:11, color:"var(--dim)" }}>
              Changed by {c.changed_by_name} · {c.changed_at}
            </div>
            {c.notes && <div style={{ fontSize:12, color:"var(--accent2)", fontStyle:"italic", marginTop:4 }}>{c.notes}</div>}
          </div>
        </div>
      ))}
    </div>
  );
}

function TransferPanel() {
  return (
    <div className="card">
      <div className="card-header">
        <div className="card-title">
          <span className="card-accent" style={{ background:"#EF4444" }}/>
          Patient Transfer
        </div>
        <button className="btn btn-primary">+ Transfer Patient</button>
      </div>
      <div className="empty-state">
        <div style={{ fontSize:28, marginBottom:8 }}>🚶</div>
        No transfers during this stay
      </div>
    </div>
  );
}

// ── TREATMENT PANEL ───────────────────────────────────────────────────────────
const STATUS_PILL = {
  Completed:  { bg:"rgba(16,185,129,.12)",  color:"#10b981" },
  Pending:    { bg:"rgba(245,158,11,.12)",  color:"#f59e0b" },
  Processing: { bg:"rgba(59,130,246,.12)",  color:"#3b82f6" },
  Scheduled:  { bg:"rgba(124,58,237,.12)",  color:"#7c3aed" },
  Cancelled:  { bg:"rgba(239,68,68,.12)",   color:"#ef4444" },
};
const MODALITY_COLOR = {
  "X-Ray":   { bg:"rgba(59,130,246,.12)",  color:"#3b82f6" },
  "USG":     { bg:"rgba(16,185,129,.12)",  color:"#10b981" },
  "CT Scan": { bg:"rgba(245,158,11,.12)",  color:"#f59e0b" },
  "MRI":     { bg:"rgba(124,58,237,.12)",  color:"#7c3aed" },
  "PET":     { bg:"rgba(239,68,68,.12)",   color:"#ef4444" },
};

function Modal({ title, onClose, children }) {
  return (
    <div className="modal-bg" onClick={onClose}>
      <div className="modal-box" onClick={e => e.stopPropagation()}>
        <div className="modal-title">
          {title}
          <button onClick={onClose} style={{ background:"none",border:"none",color:"var(--muted)",cursor:"pointer",fontSize:18,lineHeight:1 }}>✕</button>
        </div>
        {children}
      </div>
    </div>
  );
}

function PrescriptionModal({ onClose, editData }) {
  const isEdit = Boolean(editData);
  return (
    <Modal title={isEdit ? "Edit Prescription" : "Add Prescription"} onClose={onClose}>
      <div className="modal-grid">
        <div className="field modal-full">
          <label>Prescribed By</label>
          <select className="input select-i" defaultValue={editData?.prescribed_by_name||""}>
            <option value="">Select doctor</option>
            {DOCTORS.map(d => <option key={d.id} value={d.doctor_name}>{d.doctor_name}</option>)}
          </select>
        </div>
        <div className="field">
          <label>Prescribed Date</label>
          <input className="input" type="date" defaultValue={editData?.prescribed_date||"2026-04-01"}/>
        </div>
        <div className="field">
          <label>Prescribed Time</label>
          <input className="input" type="time" defaultValue={editData?.prescribed_time||""}/>
        </div>
        <div className="field modal-full">
          <label>Notes</label>
          <textarea className="input textarea" defaultValue={editData?.notes||""} placeholder="Prescription notes…"/>
        </div>
      </div>
      <div style={{ fontSize:11, color:"var(--muted)", marginBottom:10, fontWeight:600, textTransform:"uppercase", letterSpacing:".07em" }}>Medicines</div>
      {[{ label:"Medicine", w:"1fr" },{ label:"Dosage", w:"80px" },{ label:"Route", w:"90px" },{ label:"Frequency", w:"120px" },{ label:"Instructions", w:"1fr" }].map((h,i) => null)}
      {(editData?.medicines||[{ medicine_title:"", dosage:"", route:"Oral", frequency:"Once Daily", instructions:"" }]).map((m,i) => (
        <div key={i} style={{ display:"grid", gridTemplateColumns:"1fr 70px 90px 120px 1fr 28px", gap:6, marginBottom:6, alignItems:"end" }}>
          <div className="field"><label style={{ fontSize:9 }}>Medicine</label><input className="input" defaultValue={m.medicine_title} placeholder="Medicine name"/></div>
          <div className="field"><label style={{ fontSize:9 }}>Dosage</label><input className="input" defaultValue={m.dosage} placeholder="500mg"/></div>
          <div className="field"><label style={{ fontSize:9 }}>Route</label>
            <select className="input select-i" defaultValue={m.route}>
              {["Oral","IV","IM","SC","Topical","Sublingual","Inhaled","Rectal","Nasal","Other"].map(r => <option key={r}>{r}</option>)}
            </select>
          </div>
          <div className="field"><label style={{ fontSize:9 }}>Frequency</label>
            <select className="input select-i" defaultValue={m.frequency}>
              {["Once Daily","Twice Daily","Thrice Daily","Every 4 Hours","Every 6 Hours","Every 8 Hours","Every 12 Hours","SOS","Stat"].map(f => <option key={f}>{f}</option>)}
            </select>
          </div>
          <div className="field"><label style={{ fontSize:9 }}>Instructions</label><input className="input" defaultValue={m.instructions} placeholder="After meals"/></div>
          <button className="icon-btn del" style={{ marginTop:18 }}>✕</button>
        </div>
      ))}
      <button className="btn btn-ghost" style={{ fontSize:11, marginTop:6 }}>+ Add Medicine</button>
      <div className="modal-actions">
        <button className="btn btn-ghost" onClick={onClose}>Cancel</button>
        <button className="btn btn-primary">{isEdit ? "Update" : "Add"} Prescription</button>
      </div>
    </Modal>
  );
}

function StopMedicineModal({ medicine, onClose }) {
  return (
    <Modal title={`Stop — ${medicine.medicine_title}`} onClose={onClose}>
      <div style={{ background:"rgba(239,68,68,.08)", border:"1px solid rgba(239,68,68,.2)", borderRadius:8, padding:"10px 14px", fontSize:12, color:"#ef4444", marginBottom:16 }}>
        ⚠ This will mark the medicine as stopped and record the reason.
      </div>
      <div className="modal-grid">
        <div className="field modal-full">
          <label>Stop Reason <span style={{ color:"#ef4444" }}>*</span></label>
          <input className="input" placeholder="e.g. Switched to oral, Side effect observed…"/>
        </div>
        <div className="field">
          <label>End Date</label>
          <input className="input" type="date" defaultValue="2026-04-03"/>
        </div>
      </div>
      <div className="modal-actions">
        <button className="btn btn-ghost" onClick={onClose}>Cancel</button>
        <button className="btn" style={{ background:"rgba(239,68,68,.15)", color:"#ef4444", border:"1px solid rgba(239,68,68,.3)" }}>Stop Medicine</button>
      </div>
    </Modal>
  );
}

function LabModal({ onClose, editData, isResult }) {
  const isEdit = Boolean(editData);
  return (
    <Modal title={isResult ? `Add Result — ${editData?.test_name}` : isEdit ? "Edit Lab Order" : "Add Lab Order"} onClose={onClose}>
      {!isResult && (
        <div className="modal-grid">
          <div className="field modal-full">
            <label>Test Name <span style={{ color:"#ef4444" }}>*</span></label>
            <input className="input" defaultValue={editData?.test_name||""} placeholder="e.g. Complete Blood Count (CBC)"/>
          </div>
          <div className="field">
            <label>Ordered By</label>
            <select className="input select-i"><option>Dr. Priya Mehta</option>{DOCTORS.map(d=><option key={d.id}>{d.doctor_name}</option>)}</select>
          </div>
          <div className="field">
            <label>Order Date</label>
            <input className="input" type="date" defaultValue={editData?.order_date||"2026-04-01"}/>
          </div>
          <div className="field">
            <label>Status</label>
            <select className="input select-i" defaultValue={editData?.status||"Pending"}>
              {["Pending","Processing","Completed","Cancelled"].map(s=><option key={s}>{s}</option>)}
            </select>
          </div>
          <div className="field modal-full">
            <label>Notes</label>
            <textarea className="input textarea" defaultValue={editData?.notes||""} placeholder="Additional notes…"/>
          </div>
        </div>
      )}
      {isResult && (
        <div className="modal-grid">
          <div className="field modal-full">
            <label>Result Value <span style={{ color:"#ef4444" }}>*</span></label>
            <textarea className="input textarea" defaultValue={editData?.result_value||""} placeholder="Enter lab result values…" style={{ minHeight:100 }}/>
          </div>
          <div className="field">
            <label>Result Date</label>
            <input className="input" type="date" defaultValue="2026-04-01"/>
          </div>
          <div className="field">
            <label>Status</label>
            <select className="input select-i" defaultValue="Completed"><option>Completed</option></select>
          </div>
          <div className="field modal-full">
            <label>Notes</label>
            <textarea className="input textarea" placeholder="Interpretation notes…"/>
          </div>
        </div>
      )}
      <div className="modal-actions">
        <button className="btn btn-ghost" onClick={onClose}>Cancel</button>
        <button className="btn btn-primary">{isResult ? "Save Result" : isEdit ? "Update Order" : "Add Order"}</button>
      </div>
    </Modal>
  );
}

function RadiologyModal({ onClose, editData, isResult }) {
  const isEdit = Boolean(editData);
  return (
    <Modal title={isResult ? `Add Report — ${editData?.test_name}` : isEdit ? "Edit Radiology Order" : "Add Radiology Order"} onClose={onClose}>
      {!isResult && (
        <div className="modal-grid">
          <div className="field modal-full">
            <label>Test Name <span style={{ color:"#ef4444" }}>*</span></label>
            <input className="input" defaultValue={editData?.test_name||""} placeholder="e.g. Chest X-Ray PA View"/>
          </div>
          <div className="field">
            <label>Modality</label>
            <select className="input select-i" defaultValue={editData?.modality||"X-Ray"}>
              {["X-Ray","USG","CT Scan","MRI","PET","Other"].map(m=><option key={m}>{m}</option>)}
            </select>
          </div>
          <div className="field">
            <label>Ordered By</label>
            <select className="input select-i"><option>Dr. Priya Mehta</option>{DOCTORS.map(d=><option key={d.id}>{d.doctor_name}</option>)}</select>
          </div>
          <div className="field">
            <label>Order Date</label>
            <input className="input" type="date" defaultValue={editData?.order_date||"2026-04-01"}/>
          </div>
          <div className="field">
            <label>Status</label>
            <select className="input select-i" defaultValue={editData?.status||"Scheduled"}>
              {["Scheduled","Processing","Completed","Cancelled"].map(s=><option key={s}>{s}</option>)}
            </select>
          </div>
          <div className="field modal-full">
            <label>Notes</label>
            <textarea className="input textarea" defaultValue={editData?.notes||""} placeholder="Clinical indication…"/>
          </div>
        </div>
      )}
      {isResult && (
        <div className="modal-grid">
          <div className="field modal-full">
            <label>Radiologist Report <span style={{ color:"#ef4444" }}>*</span></label>
            <textarea className="input textarea" defaultValue={editData?.result||""} placeholder="Enter radiologist findings…" style={{ minHeight:100 }}/>
          </div>
          <div className="field">
            <label>Report Date</label>
            <input className="input" type="date" defaultValue="2026-04-01"/>
          </div>
          <div className="field modal-full">
            <label>Notes</label>
            <textarea className="input textarea" placeholder="Clinical correlation…"/>
          </div>
        </div>
      )}
      <div className="modal-actions">
        <button className="btn btn-ghost" onClick={onClose}>Cancel</button>
        <button className="btn btn-primary">{isResult ? "Save Report" : isEdit ? "Update Order" : "Add Order"}</button>
      </div>
    </Modal>
  );
}

function TreatmentPanel() {
  const [sub, setSub]     = useState("rx");
  const [modal, setModal] = useState(null); // { type, data?, isResult? }

  const closeModal = () => setModal(null);

  return (
    <>
      <div className="card">
        <div className="card-header">
          <div className="card-title">
            <span className="card-accent" style={{ background:"#F59E0B" }}/>
            Treatment & Orders
          </div>
          <button className="btn btn-primary" onClick={() => setModal({ type: sub === "rx" ? "rx" : sub === "lab" ? "lab" : "rad" })}>
            + {sub === "rx" ? "Add Prescription" : sub === "lab" ? "Add Lab Order" : "Add Radiology Order"}
          </button>
        </div>

        {/* Sub-tabs */}
        <div className="treat-sub-tabs">
          {[
            { id:"rx",  label:`💊 Prescriptions (${PRESCRIPTIONS.length})` },
            { id:"lab", label:`🧪 Lab Orders (${LAB_ORDERS.length})` },
            { id:"rad", label:`🩻 Radiology (${RADIOLOGY_ORDERS.length})` },
          ].map(t => (
            <button key={t.id} className={`stab ${sub===t.id?"active":""}`} onClick={() => setSub(t.id)}>{t.label}</button>
          ))}
        </div>

        {/* ── Prescriptions ── */}
        {sub === "rx" && (
          PRESCRIPTIONS.length === 0
            ? <div className="empty-state">No prescriptions yet</div>
            : PRESCRIPTIONS.map(rx => (
              <div className="rx-item" key={rx.id}>
                <div style={{ display:"flex", alignItems:"center", gap:8, marginBottom:10 }}>
                  <Av name={rx.prescribed_by_name} size={28} color={doctorColor(rx.prescribed_by_name)}/>
                  <div>
                    <span style={{ fontSize:12, fontWeight:500 }}>{rx.prescribed_by_name}</span>
                    <span style={{ fontFamily:"'IBM Plex Mono',monospace", fontSize:10, color:"var(--muted)", marginLeft:8 }}>{rx.prescribed_date} · {rx.prescribed_time}</span>
                  </div>
                  {rx.notes && <span style={{ fontSize:11, color:"var(--muted)", fontStyle:"italic", marginLeft:"auto" }}>{rx.notes}</span>}
                  <button className="icon-btn" onClick={() => setModal({ type:"rx", data:rx })}>✎</button>
                  <button className="icon-btn del">🗑</button>
                </div>
                {rx.medicines.map(m => (
                  <div className="medicine-row" key={m.id}>
                    <span className="med-name">{m.medicine_title}</span>
                    <span className="med-chip">{m.medicine_type}</span>
                    <span className="med-chip" style={{ color:"var(--accent2)" }}>{m.dosage}</span>
                    <span className="med-chip">{m.route}</span>
                    <span className="med-chip">{m.frequency}</span>
                    {m.duration_days && <span className="med-chip">{m.duration_days}d</span>}
                    {m.instructions  && <span style={{ fontSize:11, color:"var(--muted)", flex:1 }}>{m.instructions}</span>}
                    <span style={{ marginLeft:"auto" }}>
                      {m.active === 1
                        ? <span className="active-m" style={{ fontSize:10, padding:"2px 7px", borderRadius:8, fontWeight:600, background:"rgba(16,185,129,.1)", color:"#10b981" }}>Active</span>
                        : <span style={{ fontSize:10, padding:"2px 7px", borderRadius:8, fontWeight:600, background:"rgba(239,68,68,.1)", color:"#ef4444" }} title={m.stop_reason}>Stopped</span>
                      }
                    </span>
                    {m.active === 1 && <button className="icon-btn del" style={{ fontSize:10 }} onClick={() => setModal({ type:"stop", data:m })}>Stop</button>}
                    <button className="icon-btn" onClick={() => setModal({ type:"editMed", data:m })}>✎</button>
                  </div>
                ))}
              </div>
            ))
        )}

        {/* ── Lab Orders ── */}
        {sub === "lab" && (
          LAB_ORDERS.length === 0
            ? <div className="empty-state">No lab orders yet</div>
            : LAB_ORDERS.map(lab => {
              const sp = STATUS_PILL[lab.status] || STATUS_PILL.Pending;
              return (
                <div className="lab-row" key={lab.id}>
                  <div>
                    <div style={{ fontSize:13, fontWeight:500, marginBottom:3 }}>{lab.test_name}</div>
                    <div style={{ fontSize:11, color:"var(--muted)" }}>Ordered by {lab.ordered_by_name} · {lab.order_date}</div>
                    {lab.result_value && (
                      <div className="result-box">
                        <div style={{ fontSize:10, color:"var(--dim)", textTransform:"uppercase", letterSpacing:".06em", marginBottom:4 }}>
                          Result · {lab.result_date}
                        </div>
                        {lab.result_value}
                        {lab.notes && <div style={{ marginTop:4, color:"var(--accent2)", fontSize:11, fontStyle:"italic" }}>{lab.notes}</div>}
                      </div>
                    )}
                    {!lab.result_value && lab.notes && (
                      <div style={{ fontSize:11, color:"var(--amber)", marginTop:4 }}>📌 {lab.notes}</div>
                    )}
                  </div>
                  <div>
                    <span className="stat-pill" style={{ background:sp.bg, color:sp.color }}>
                      <span style={{ width:5,height:5,borderRadius:"50%",background:"currentColor",display:"inline-block" }}/>
                      {lab.status}
                    </span>
                  </div>
                  <div style={{ display:"flex", gap:6, flexWrap:"wrap" }}>
                    {lab.status !== "Completed" && (
                      <button className="btn btn-ghost btn-sm" style={{ fontSize:11, padding:"4px 10px" }}
                        onClick={() => setModal({ type:"lab", data:lab, isResult:true })}>+ Result</button>
                    )}
                    <button className="icon-btn" onClick={() => setModal({ type:"lab", data:lab })}>✎</button>
                    <button className="icon-btn del">🗑</button>
                  </div>
                </div>
              );
            })
        )}

        {/* ── Radiology Orders ── */}
        {sub === "rad" && (
          RADIOLOGY_ORDERS.length === 0
            ? <div className="empty-state">No radiology orders yet</div>
            : RADIOLOGY_ORDERS.map(rad => {
              const sp  = STATUS_PILL[rad.status] || STATUS_PILL.Pending;
              const mc  = MODALITY_COLOR[rad.modality] || { bg:"var(--bg3)", color:"var(--muted)" };
              return (
                <div className="lab-row" key={rad.id}>
                  <div>
                    <div style={{ display:"flex", alignItems:"center", gap:8, marginBottom:3 }}>
                      <span style={{ fontSize:13, fontWeight:500 }}>{rad.test_name}</span>
                      <span className="mod-chip" style={{ background:mc.bg, color:mc.color }}>{rad.modality}</span>
                    </div>
                    <div style={{ fontSize:11, color:"var(--muted)" }}>Ordered by {rad.ordered_by_name} · {rad.order_date}</div>
                    {rad.result && (
                      <div className="result-box">
                        <div style={{ fontSize:10, color:"var(--dim)", textTransform:"uppercase", letterSpacing:".06em", marginBottom:4 }}>
                          Report · {rad.result_date}
                        </div>
                        {rad.result}
                        {rad.notes && <div style={{ marginTop:4, color:"var(--accent2)", fontSize:11, fontStyle:"italic" }}>{rad.notes}</div>}
                      </div>
                    )}
                    {!rad.result && rad.notes && (
                      <div style={{ fontSize:11, color:"var(--amber)", marginTop:4 }}>📌 {rad.notes}</div>
                    )}
                  </div>
                  <div>
                    <span className="stat-pill" style={{ background:sp.bg, color:sp.color }}>
                      <span style={{ width:5,height:5,borderRadius:"50%",background:"currentColor",display:"inline-block" }}/>
                      {rad.status}
                    </span>
                  </div>
                  <div style={{ display:"flex", gap:6, flexWrap:"wrap" }}>
                    {rad.status !== "Completed" && (
                      <button className="btn btn-ghost btn-sm" style={{ fontSize:11, padding:"4px 10px" }}
                        onClick={() => setModal({ type:"rad", data:rad, isResult:true })}>+ Report</button>
                    )}
                    <button className="icon-btn" onClick={() => setModal({ type:"rad", data:rad })}>✎</button>
                    <button className="icon-btn del">🗑</button>
                  </div>
                </div>
              );
            })
        )}
      </div>

      {/* Modals */}
      {modal?.type === "rx"     && <PrescriptionModal  onClose={closeModal} editData={modal.data}/>}
      {modal?.type === "stop"   && <StopMedicineModal  onClose={closeModal} medicine={modal.data}/>}
      {modal?.type === "lab"    && <LabModal           onClose={closeModal} editData={modal.data} isResult={modal.isResult}/>}
      {modal?.type === "rad"    && <RadiologyModal     onClose={closeModal} editData={modal.data} isResult={modal.isResult}/>}
    </>
  );
}

// ── MAIN PAGE ─────────────────────────────────────────────────────────────────
const TABS = [
  { id:"vitals",    label:"Vitals",        icon:"🩺" },
  { id:"rounds",    label:"Doctor Rounds", icon:"👨‍⚕️" },
  { id:"nursing",   label:"Nursing Notes", icon:"📋" },
  { id:"diet",      label:"Diet Plan",     icon:"🍽️" },
  { id:"treatment", label:"Treatment",     icon:"💊" },
  { id:"change",    label:"Dr. Change",    icon:"🔄" },
  { id:"transfer",  label:"Transfer",      icon:"🚶" },
];

const today = new Date("2026-05-01");
const admitted = new Date(ADMISSION.admission_date);
const daysAdmitted = Math.floor((today - admitted) / 86400000);
const daysLeft = Math.max(0, Math.floor((new Date(ADMISSION.expected_discharge_date) - today) / 86400000));

export default function AdmissionDetail() {
  const [activeTab, setActiveTab] = useState("treatment");

  return (
    <>
      <style>{css}</style>
      <div className="page">
        <button className="back-btn">← Back to Admissions</button>

        {/* Header card */}
        <div className="header-card">
          <div>
            <div style={{ display:"flex", alignItems:"center", gap:12, marginBottom:10 }}>
              <Av name={ADMISSION.patient_name} size={52} color="#5E7BFF"/>
              <div>
                <div className="patient-name">{ADMISSION.patient_name}</div>
                <div className="patient-phone">{ADMISSION.patient_phone}</div>
              </div>
              <span className={`status-badge status-${ADMISSION.status.toLowerCase()}`}>
                <span style={{ width:6,height:6,borderRadius:"50%",background:"currentColor",display:"inline-block" }}/>
                {ADMISSION.status}
              </span>
              <span style={{ fontSize:11, padding:"3px 10px", borderRadius:12, background:"rgba(245,158,11,.12)", color:"#F59E0B", fontWeight:600 }}>
                {ADMISSION.admission_type}
              </span>
            </div>

            <div className="admission-no">{ADMISSION.admission_no}</div>

            {/* Doctors row */}
            <div className="doctors-row">
              {DOCTORS.map(d => (
                <div className="doctor-chip" key={d.id}>
                  <div className="doc-av" style={{ background:doctorColor(d.doctor_name) }}>{initials(d.doctor_name)}</div>
                  <div>
                    <div className="doc-name">{d.doctor_name}</div>
                    <div className="doc-role">{d.role} · {d.specialization}</div>
                  </div>
                </div>
              ))}
            </div>

            <div className="meta-grid">
              {[
                ["Ward",       ADMISSION.ward_title],
                ["Bed",        ADMISSION.bed_number],
                ["Admitted",   fmtDate(ADMISSION.admission_date)],
                ["Expected D/C", fmtDate(ADMISSION.expected_discharge_date)],
                ["Clinic",     ADMISSION.clinic_title],
                ["Source",     ADMISSION.source],
                ["Days In",    `${daysAdmitted} days`],
                ["Days Left",  `${daysLeft} days`],
              ].map(([l,v]) => (
                <div className="meta-item" key={l}>
                  <div className="meta-label">{l}</div>
                  <div className="meta-value">{v}</div>
                </div>
              ))}
            </div>

            {ADMISSION.diagnosis && (
              <div style={{ marginTop:12, background:"var(--bg3)", border:"1px solid var(--border)", borderRadius:10, padding:"10px 14px" }}>
                <div style={{ fontSize:10, color:"var(--muted)", textTransform:"uppercase", letterSpacing:".07em", marginBottom:3 }}>Diagnosis</div>
                <div style={{ fontSize:13, color:"var(--text)", lineHeight:1.6 }}>{ADMISSION.diagnosis}</div>
              </div>
            )}
          </div>

          {/* Days left box */}
          <div style={{ display:"flex", flexDirection:"column", gap:12 }}>
            <div className="days-box">
              <div className="days-num">{daysLeft}</div>
              <div className="days-label">days left</div>
            </div>
            <div style={{ background:"var(--bg3)", border:"1px solid var(--border)", borderRadius:12, padding:"12px 16px", textAlign:"center" }}>
              <div style={{ fontFamily:"'IBM Plex Mono',monospace", fontSize:22, fontWeight:500, color:"var(--accent2)" }}>{daysAdmitted}</div>
              <div style={{ fontSize:11, color:"var(--muted)", marginTop:2 }}>days admitted</div>
            </div>
            <button className="btn btn-primary" style={{ justifyContent:"center" }}>Discharge</button>
            <button className="btn btn-ghost"   style={{ justifyContent:"center" }}>Transfer</button>
          </div>
        </div>

        {/* Tabs */}
        <div className="tabs">
          {TABS.map(t => (
            <button key={t.id} className={`tab ${activeTab===t.id?"active":""}`} onClick={() => setActiveTab(t.id)}>
              <span>{t.icon}</span> {t.label}
            </button>
          ))}
        </div>

        {/* Tab content */}
        {activeTab === "vitals"    && <VitalsPanel/>}
        {activeTab === "rounds"    && <RoundsPanel/>}
        {activeTab === "nursing"   && <NursingPanel/>}
        {activeTab === "diet"      && <DietPanel/>}
        {activeTab === "treatment" && <TreatmentPanel/>}
        {activeTab === "change"    && <DoctorChangePanel/>}
        {activeTab === "transfer"  && <TransferPanel/>}
      </div>
    </>
  );
}
